import { useEffect } from 'react';

export default function PublicAvisoLegal() {
  useEffect(() => { document.title = 'Aviso Legal · Revix.es'; }, []);

  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 py-16 sm:py-24 text-[#1d1d1f]" data-testid="page-aviso-legal">
      <header className="mb-10">
        <p className="text-xs uppercase tracking-wider text-[#6E6E73] mb-2">Legal</p>
        <h1 className="text-3xl sm:text-5xl font-bold tracking-tight">Aviso Legal</h1>
        <p className="text-sm text-[#6E6E73] mt-3">Última actualización: mayo 2026 · Ley 34/2002 LSSI-CE</p>
      </header>

      <section className="space-y-6 text-[15px] leading-relaxed">
        <h2 className="text-xl font-semibold mt-8">1. Datos identificativos del titular</h2>
        <p>
          En cumplimiento de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la
          Información y del Comercio Electrónico (LSSI-CE), te informamos de que el titular del sitio
          web <strong>https://revix.es</strong> es:
        </p>
        <ul className="list-none space-y-1 pl-0">
          <li><strong>Titular:</strong> Revix.es</li>
          <li><strong>Actividad:</strong> Reparación de dispositivos electrónicos y gestión de incidencias.</li>
          <li><strong>Domicilio:</strong> España</li>
          <li><strong>Email de contacto:</strong> <a className="underline" href="mailto:help@revix.es">help@revix.es</a></li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">2. Objeto</h2>
        <p>
          El presente aviso legal regula el uso del sitio web https://revix.es. La navegación por la
          web atribuye la condición de usuario e implica la aceptación plena y sin reservas de todas
          y cada una de las disposiciones incluidas en este aviso legal.
        </p>

        <h2 className="text-xl font-semibold mt-8">3. Condiciones de uso</h2>
        <p>El usuario se compromete a:</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Hacer un uso adecuado y lícito del sitio web, conforme a la legislación vigente.</li>
          <li>No realizar actividades contrarias a la moral, las buenas costumbres o el orden público.</li>
          <li>No introducir programas, virus, o cualquier otro elemento que pueda dañar la web o sus sistemas.</li>
          <li>Proporcionar información veraz y actualizada al utilizar formularios o servicios.</li>
          <li>Respetar los derechos de propiedad intelectual e industrial.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">4. Propiedad intelectual e industrial</h2>
        <p>
          Todos los contenidos del sitio web (textos, imágenes, marcas, logotipos, diseño, código
          fuente) son propiedad de Revix.es o se utilizan con autorización de sus titulares.
          Queda prohibida su reproducción, distribución, comunicación pública o transformación sin
          autorización expresa por escrito.
        </p>

        <h2 className="text-xl font-semibold mt-8">5. Exclusión de responsabilidad</h2>
        <p>
          Revix.es no se hace responsable, en ningún caso, de los daños y perjuicios de cualquier
          naturaleza que pudieran ocasionar, a título enunciativo:
        </p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>Errores u omisiones en los contenidos publicados.</li>
          <li>Falta de disponibilidad puntual del sitio web por mantenimiento o causas ajenas.</li>
          <li>Transmisión de virus o programas maliciosos por terceros, a pesar de las medidas adoptadas.</li>
          <li>Uso indebido del sitio web por parte de los usuarios.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">6. Enlaces a terceros</h2>
        <p>
          El sitio puede contener enlaces a sitios de terceros (aseguradoras, proveedores logísticos,
          páginas oficiales). Revix.es no asume responsabilidad sobre los contenidos, políticas de
          privacidad o prácticas de dichos sitios.
        </p>

        <h2 className="text-xl font-semibold mt-8">7. Protección de datos</h2>
        <p>
          El tratamiento de datos personales se rige por nuestra{' '}
          <a className="underline" href="/privacidad">Política de Privacidad</a> y nuestra{' '}
          <a className="underline" href="/cookies">Política de Cookies</a>.
        </p>

        <h2 className="text-xl font-semibold mt-8">8. Modificaciones</h2>
        <p>
          Revix.es se reserva el derecho a modificar el presente aviso legal en cualquier momento.
          Los cambios se publicarán en esta misma página, indicando la fecha de actualización.
        </p>

        <h2 className="text-xl font-semibold mt-8">9. Legislación aplicable y jurisdicción</h2>
        <p>
          Este aviso legal se rige por la legislación española. Para la resolución de cualquier
          controversia, las partes se someten a los Juzgados y Tribunales del domicilio del usuario
          si tiene la condición de consumidor, conforme al Real Decreto Legislativo 1/2007 de
          Defensa de los Consumidores y Usuarios.
        </p>
      </section>
    </article>
  );
}
